import styled from 'styled-components'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'
// @ts-ignore
import { sys } from '@netbasequid/theme'

// TODO: reuse this with system-message-live-report

const { dark, fontWeight } = sys

export const Title = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.systemMessage.title
})`
  font-family: var(--large-font-family);
  font-weight: ${fontWeight.regular};
  font-size: 36px;
  line-height: 42px;
  margin-bottom: 20px;
`

export const Content = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.systemMessage.content
})`
  font-family: var(--large-font-family);
  line-height: ${sys.typescale[16].lineHeight};
  font-size: ${sys.typescale[16].size};
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  width: 400px;
  margin: 40px auto;
  & > button {
    flex: 1;
  }
`

export const Footer = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.systemMessage.footer
})`
  color: ${dark.text.weak};
  line-height: ${sys.typescale[12].lineHeight};
  font-size: ${sys.typescale[12].size};
`
